import "./style.css";
import { PlanetGame } from "./game";
import { NetworkClient } from "./network";
import type { PlanetConfig } from "./types";

function required<T extends Element>(selector: string): T {
  const element = document.querySelector<T>(selector);
  if (!element) throw new Error(`Missing required element ${selector}`);
  return element;
}

const canvas = required<HTMLCanvasElement>("#game");
const join = required<HTMLElement>("#join");
const joinButton = required<HTMLButtonElement>("#join-button");
const username = required<HTMLInputElement>("#username");
const joinState = required<HTMLElement>("#join-state");
let game: PlanetGame | null = null;

async function start(): Promise<void> {
  joinButton.disabled = true;
  joinState.textContent = "Загрузка конфигурации планет…";
  try {
    const configResponse = await fetch("/api/config", { cache: "no-store" });
    if (!configResponse.ok) throw new Error(`Config HTTP ${configResponse.status}`);
    const config = await configResponse.json() as PlanetConfig;
    const network = new NetworkClient();
    joinState.textContent = "Подключение к пространству…";
    game = new PlanetGame(canvas, config, network);
    await network.connect(username.value.trim() || "Explorer");
    join.classList.remove("visible");
    canvas.focus();
  } catch (error) {
    game = null;
    joinState.textContent = error instanceof Error ? error.message : String(error);
    joinButton.disabled = false;
  }
}

joinButton.addEventListener("click", () => void start());
username.addEventListener("keydown", (event) => {
  if (event.key === "Enter") void start();
});
